// Auto-generated by @vm0/firewalls-generator.
// Regenerate: cd turbo && pnpm -F @vm0/firewalls-generator generate
//
// DO NOT EDIT THIS FILE MANUALLY.
import type { FirewallPermissionSummaryMetadata } from "./types";

export const BUILTIN_FIREWALL_FIXED_HOST_OWNERS = {
  "7i30hpv4bo9ud5mhianq.pika.art": "pika",
  "a.klaviyo.com": "klaviyo",
  "account-d.docusign.com": "docusign",
  "account.docusign.com": "docusign",
  "actions.zapier.com": "zapier",
  "aeroapi.flightaware.com": "flightaware",
  "amplitude.com": "amplitude",
  "analytics.eu.amplitude.com": "amplitude",
  "analyticsadmin.googleapis.com": "google-analytics",
  "analyticsdata.googleapis.com": "google-analytics",
  "api-cloud.browserstack.com": "browserstack",
  "api-inference.huggingface.co": "hugging-face",
  "api-ipv4.porkbun.com": "porkbun",
  "api.adzuna.com": "adzuna",
  "api.agentmail.to": "agentmail",
  "api.agora.io": "agora",
  "api.ahrefs.com": "ahrefs",
  "api.airtable.com": "airtable",
  "api.amadeus.com": "amadeus",
  "api.anthropic.com": "anthropic-managed-agents",
  "api.apify.com": "apify",
  "api.apollo.io": "apollo",
  "api.ashbyhq.com": "ashby",
  "api.atlascloud.ai": "atlascloud",
  "api.atlassian.com": "atlassian",
  "api.attio.com": "attio",
  "api.aviationstack.com": "aviationstack",
  "api.axiom.co": "axiom",
  "api.bfl.ai": "bfl",
  "api.bitrefill.com": "bitrefill",
  "api.bland.ai": "bland",
  "api.box.com": "box",
  "api.brevo.com": "brevo",
  "api.brex.com": "brex",
  "api.brightdata.com": "bright-data",
  "api.browser-use.com": "browser-use",
  "api.browserbase.com": "browserbase",
  "api.browserstack.com": "browserstack",
  "api.bubblemaps.io": "bubblemaps",
  "api.buffer.com": "buffer",
  "api.bufferapp.com": "buffer",
  "api.builtwith.com": "builtwith",
  "api.cal.com": "cal-com",
  "api.calendly.com": "calendly",
  "api.canva.com": "canva",
  "api.checkr.com": "checkr",
  "api.clerk.com": "clerk",
  "api.clickup.com": "clickup",
  "api.close.com": "close",
  "api.cloudflare.com": "cloudflare",
  "api.coingecko.com": "coingecko",
  "api.coresignal.com": "coresignal",
  "api.cronlytic.com": "cronlytic",
  "api.crustdata.com": "crustdata",
  "api.cursor.com": "cursor",
  "api.customer.io": "customer-io",
  "api.db9.ai": "db9",
  "api.deepseek.com": "deepseek",
  "api.dev.runwayml.com": "runway",
  "api.diffbot.com": "diffbot",
  "api.dify.ai": "dify",
  "api.doppler.com": "doppler",
  "api.drive9.ai": "drive9",
  "api.dropboxapi.com": "dropbox",
  "api.duffel.com": "duffel",
  "api.e2b.app": "e2b",
  "api.elevenlabs.io": "elevenlabs",
  "api.etherscan.io": "etherscan",
  "api.eu.amplitude.com": "amplitude",
  "api.eu.bfl.ai": "bfl",
  "api.exa.ai": "exa",
  "api.explorium.ai": "explorium",
  "api.fal.ai": "fal",
  "api.figma.com": "figma",
  "api.firecrawl.dev": "firecrawl",
  "api.fireflies.ai": "fireflies",
  "api.g.alchemy.com": "alchemy",
  "api.getzep.com": "zep",
  "api.github.com": "github",
  "api.groq.com": "groq",
  "api.gumroad.com": "gumroad",
  "api.helicone.ai": "helicone",
  "api.hellosign.com": "dropbox-sign",
  "api.heygen.com": "heygen",
  "api.hitem3d.ai": "hitem3d",
  "api.honcho.dev": "honcho",
  "api.hubapi.com": "hubspot",
  "api.hume.ai": "hume",
  "api.hunter.io": "hunter",
  "api.imgur.com": "imgur",
  "api.instantly.ai": "instantly",
  "api.intercom.io": "intercom",
  "api.jotform.com": "jotform",
  "api.letsdeel.com": "deel",
  "api.line.me": "line",
  "api.linear.app": "linear",
  "api.lumalabs.ai": "luma-ai",
  "api.manus.ai": "manus",
  "api.mapbox.com": "mapbox",
  "api.maskdb.ai": "maskdb",
  "api.massive.com": "massive",
  "api.mathpix.com": "mathpix",
  "api.mem0.ai": "mem0",
  "api.mercury.com": "mercury",
  "api.meshy.ai": "meshy",
  "api.minimax.io": "minimax",
  "api.miro.com": "miro",
  "api.mixpanel.com": "mixpanel",
  "api.modal.com": "modal",
  "api.monday.com": "monday",
  "api.moss.dev": "moss",
  "api.notion.com": "notion",
  "api.novita.ai": "novita",
  "api.nyne.ai": "nyne",
  "api.openai.com": "openai",
  "api.openweathermap.org": "openweather",
  "api.pandadoc.com": "pandadoc",
  "api.parallel.ai": "parallel",
  "api.pdf.co": "pdfco",
  "api.pdf4me.com": "pdf4me",
  "api.pdforge.com": "pdforge",
  "api.peopledatalabs.com": "people-data-labs",
  "api.perplexity.ai": "perplexity",
  "api.pexels.com": "pexels",
  "api.pinecone.io": "pinecone",
  "api.pipedream.com": "pipedream",
  "api.pipedrive.com": "pipedrive",
  "api.podchaser.com": "podchaser",
  "api.polygon.io": "massive",
  "api.porkbun.com": "porkbun",
  "api.printful.com": "printful",
  "api.prisma.io": "prisma-postgres",
  "api.pushinator.com": "pushinator",
  "api.render.com": "render",
  "api.rentcast.io": "rentcast",
  "api.replicate.com": "replicate",
  "api.resend.com": "resend",
  "api.revenuecat.com": "revenuecat",
  "api.sd-rtn.com": "agora",
  "api.search.brave.com": "brave-search",
  "api.segmentapis.com": "segment",
  "api.semrush.com": "semrush",
  "api.sendgrid.com": "sendgrid",
  "api.short.io": "shortio",
  "api.similarweb.com": "similarweb",
  "api.slock.ai": "slock",
  "api.smith.langchain.com": "langsmith",
  "api.sociavault.com": "sociavault",
  "api.spotify.com": "spotify",
  "api.stability.ai": "stability-ai",
  "api.streak.com": "streak",
  "api.stripe.com": "stripe",
  "api.supabase.com": "supabase",
  "api.supadata.ai": "supadata",
  "api.supermemory.ai": "supermemory",
  "api.tavily.com": "tavily",
  "api.todoist.com": "todoist",
  "api.together.ai": "together",
  "api.tripo3d.ai": "tripo",
  "api.tryprofound.com": "profound",
  "api.twenty.com": "twenty",
  "api.twilio.com": "twilio",
  "api.typeform.com": "typeform",
  "api.us.bfl.ai": "bfl",
  "api.v0.dev": "v0",
  "api.vercel.com": "vercel",
  "api.wallet.paysponge.com": "sponge",
  "api.wandb.ai": "wandb",
  "api.webflow.com": "webflow",
  "api.whale-alert.io": "whale-alert",
  "api.workos.com": "workos",
  "api.x.com": "x",
  "api.xero.com": "xero",
  "api.zapsign.com.br": "zapsign",
  "api.zeptomail.com": "zeptomail",
  "api.zoom.us": "zoom",
  "api2.amplitude.com": "amplitude",
  "apis.garmin.com": "garmin-connect",
  "app-eu.wrike.com": "wrike",
  "app-us2.wrike.com": "wrike",
  "app.asana.com": "asana",
  "app.base44.com": "base44",
  "app.chatwoot.com": "chatwoot",
  "app.daytona.io": "daytona",
  "app.infisical.com": "infisical",
  "app.loops.so": "loops",
  "app.netdata.cloud": "netdata",
  "app.reportei.com": "reportei",
  "app.ticketmaster.com": "ticketmaster",
  "appengine.googleapis.com": "google-cloud",
  "artifactregistry.googleapis.com": "google-cloud",
  "au.docusign.net": "docusign",
  "backboard.railway.com": "railway",
  "bigquery.googleapis.com": "google-cloud",
  "business-api.tiktok.com": "tiktok-ads",
  "ca.docusign.net": "docusign",
  "cloud.langfuse.com": "langfuse",
  "cloud.onyx.app": "onyx",
  "cloudbilling.googleapis.com": "google-cloud",
  "cloudbuild.googleapis.com": "google-cloud",
  "cloudfunctions.googleapis.com": "google-cloud",
  "cloudresourcemanager.googleapis.com": "google-cloud",
  "coda.io": "coda",
  "codeload.github.com": "github",
  "company.clearbit.com": "clearbit",
  "compute.googleapis.com": "google-cloud",
  "connect.squareup.com": "square",
  "console.neon.tech": "neon",
  "container.googleapis.com": "google-cloud",
  "content.dropboxapi.com": "dropbox",
  "core-api.uk.plain.com": "plain",
  "data.mixpanel.com": "mixpanel",
  "datamanager.googleapis.com": "google-ads",
  "demo.docusign.net": "docusign",
  "dev.to": "devto",
  "discord.com": "discord",
  "docs.googleapis.com": "google-docs",
  "eu-api.jotform.com": "jotform",
  "eu.docusign.net": "docusign",
  "eu.infisical.com": "infisical",
  "eu.posthog.com": "posthog",
  "eu1.make.celonis.com": "make",
  "eu1.make.com": "make",
  "eu2.make.com": "make",
  "external.api.recraft.ai": "recraft",
  "fal.run": "fal",
  "files.slack.com": "slack",
  "firestore.googleapis.com": "google-cloud",
  "firewall-placeholder.vm3.ai": "bitrix",
  "generativelanguage.googleapis.com": "gemini",
  "geocode.googleapis.com": "google-maps",
  "gist.github.com": "github",
  "github.com": "github",
  "gitlab.com": "gitlab",
  "gmail.googleapis.com": "gmail",
  "googleads.googleapis.com": "google-ads",
  "graph.facebook.com": "instagram",
  "graph.instagram.com": "instagram",
  "graph.microsoft.com": "microsoft-365",
  "harvest.greenhouse.io": "greenhouse",
  "hcti.io": "htmlcsstoimage",
  "hipaa-api.jotform.com": "jotform",
  "huggingface.co": "hugging-face",
  "i.weread.qq.com": "weread",
  "iam.googleapis.com": "google-cloud",
  "images.pexels.com": "pexels",
  "intervals.icu": "intervals-icu",
  "leviathan.whale-alert.io": "whale-alert",
  "logging.googleapis.com": "google-cloud",
  "login.mailchimp.com": "mailchimp",
  "lookups.twilio.com": "twilio",
  "mailsac.com": "mailsac",
  "mcp.hitem3d.ai": "hitem3d",
  "mcp.jam.dev": "jam",
  "meet.googleapis.com": "google-meet",
  "messaging.twilio.com": "twilio",
  "mixpanel.com": "mixpanel",
  "monitoring.googleapis.com": "google-cloud",
  "na2.docusign.net": "docusign",
  "na3.docusign.net": "docusign",
  "na4.docusign.net": "docusign",
  "notify.dropboxapi.com": "dropbox",
  "npm.pkg.github.com": "github",
  "oauth.reddit.com": "reddit",
  "open.larksuite.com": "lark",
  "openapi.etsy.com": "etsy",
  "openrouter.ai": "openrouter",
  "openspeech.bytedance.com": "doubao",
  "pasta.tldv.io": "tldv",
  "person-stream.clearbit.com": "clearbit",
  "person.clearbit.com": "clearbit",
  "places.googleapis.com": "google-maps",
  "platform.reducto.ai": "reducto",
  "plausible.io": "plausible",
  "pro-api.coingecko.com": "coingecko",
  "pro-api.llama.fi": "defillama",
  "production-ams.browserless.io": "browserless",
  "production-lon.browserless.io": "browserless",
  "production-sfo.browserless.io": "browserless",
  "productlane.com": "productlane",
  "proxy.app.daytona.io": "daytona",
  "public-api.gamma.app": "gamma",
  "public-api.granola.ai": "granola",
  "public-api.luma.com": "luma",
  "pubsub.googleapis.com": "google-cloud",
  "qiita.com": "qiita",
  "queue.fal.run": "fal",
  "raw.githubusercontent.com": "github",
  "reveal.clearbit.com": "clearbit",
  "risk.clearbit.com": "clearbit",
  "router.huggingface.co": "hugging-face",
  "routes.googleapis.com": "google-maps",
  "run.googleapis.com": "google-cloud",
  "sandbox-ads.tiktok.com": "tiktok-ads",
  "scrapeninja.p.rapidapi.com": "scrapeninja",
  "search.clado.ai": "clado",
  "searchconsole.googleapis.com": "google-search-console",
  "secretmanager.googleapis.com": "google-cloud",
  "sentry.io": "sentry",
  "serpapi.com": "serpapi",
  "serverless.twilio.com": "twilio",
  "serviceusage.googleapis.com": "google-cloud",
  "sheets.googleapis.com": "google-sheets",
  "slack.com": "slack",
  "spanner.googleapis.com": "google-cloud",
  "sproutgigs.com": "sproutgigs",
  "sqladmin.googleapis.com": "google-cloud",
  "srkibaanghvsriahb.pika.art": "pika",
  "storage.googleapis.com": "google-cloud",
  "studio.twilio.com": "twilio",
  "test.api.amadeus.com": "amadeus",
  "upload.box.com": "box",
  "upload.heygen.com": "heygen",
  "uploads.github.com": "github",
  "us.cloud.langfuse.com": "langfuse",
  "us.infisical.com": "infisical",
  "us.posthog.com": "posthog",
  "us1.make.celonis.com": "make",
  "us1.make.com": "make",
  "us2.make.com": "make",
  "verify.twilio.com": "twilio",
  "videos.pexels.com": "pexels",
  "workspaceevents.googleapis.com": "google-meet",
  "www.browserstack.com": "browserstack",
  "www.docusign.net": "docusign",
  "www.faire.com": "faire",
  "www.googleapis.com": "google-calendar",
  "www.msg9.io": "msg9",
  "www.strava.com": "strava",
  "www.wixapis.com": "wix",
  "www.wrike.com": "wrike",
  "youtube.googleapis.com": "youtube",
  "{awshost+}.amazonaws.com": "aws",
  "{awshost+}.amazonaws.com.cn": "aws",
  "{awshost+}.api.aws": "aws",
  "{dc}.api.mailchimp.com": "mailchimp",
  "{deployment+}.bentoml.ai": "bentoml",
  "{deployment+}.cloud-apps.bentoml.com": "bentoml",
  "{network}.g.alchemy.com": "alchemy",
  "{pr}.vm6.ai": "test-oauth"
} as const satisfies Readonly<Record<string, FirewallPermissionSummaryMetadata["type"]>>;
